import { useDataContext } from '../context/page-context-provider';

export const useLocale = () => {
  const { pageContext } = useDataContext();
  return pageContext.locale;
};
